export const hashChangeEvent = 'ovh-routing-hash-change';
export function routing() {
    return {
        onHashChange: () => {
            window.dispatchEvent(new Event(hashChangeEvent));
        },
    };
}
export default routing;
//# sourceMappingURL=index.js.map